import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import SectionCard from '../shared/SectionCard';
import KpiGrid from '../shared/KpiGrid';
import { People, PersonAdd, Today, CalendarMonth } from '@mui/icons-material';
import { businessDashboardService } from '../../../services/dashboard';

const kpiItems = [
  { key: 'totalSubscribers', title: 'Total Subscribers', icon: <People />, format: (v) => v.toLocaleString() },
  { key: 'activeSubscribers', title: 'Active Subscribers', icon: <PersonAdd />, format: (v) => v.toLocaleString() },
  { key: 'newSubscribersToday', title: 'New Today', icon: <Today />, format: (v) => v.toLocaleString() },
  { key: 'newSubscribersThisMonth', title: 'New This Month', icon: <CalendarMonth />, format: (v) => v.toLocaleString() },
];

const SubscriberAnalyticsSection = ({ applicationId, reloadKey }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    businessDashboardService
      .getSubscribers(applicationId)
      .then((res) => setData(res.data))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [applicationId, reloadKey]);

  const trend = (data?.growthTrend || []).map((p) => ({
    label: new Date(p.month).toLocaleDateString([], { month: 'short' }),
    count: p.count,
  }));

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <KpiGrid items={kpiItems} data={data} loading={loading} error={error} />
      </Grid>
      <Grid item xs={12}>
        <SectionCard
          title="Subscriber Growth"
          loading={loading}
          error={error}
          isEmpty={!loading && !error && trend.length === 0}
          minHeight={220}
        >
          <ResponsiveContainer width="100%" height={220}>
            <LineChart data={trend}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="label" tick={{ fontSize: 12 }} />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip />
              <Line type="monotone" dataKey="count" stroke="#1565c0" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </SectionCard>
      </Grid>
    </Grid>
  );
};

export default SubscriberAnalyticsSection;
